export const INACTIVE_USERS_URL = '/organization/v2/users/inactive';
export const INACTIVE_USERS_SEND_REMINDER_URL = '/organization/v2/users/reminders';
